module.exports = __webpack_public_path__ + "static/slide-left.7ec8bafe.png";


//////////////////
// WEBPACK FOOTER
// ./app/resource/page/index/views/images/slide-left.png
// module id = 1052
// module chunks = 2